import React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { COLORS, STRINGS } from 'apps/web_forms/utils/constants';
import ls from 'local-storage';

const ToggleButton = styled.div`
	display: flex;
	align-items: center;
	margin: 0 30px;
	user-select: none;
	width: 225px;
	justify-content: flex-end;

	& .dm-rv-switch {
		height: 0;
		width: 0;
		visibility: hidden;
		display: none;
	}

	& .dm-rv-label {
		cursor: pointer;
		text-indent: -9999px;
		width: 60px;
		height: 30px;
		background: ${COLORS.textColor};
		display: block;
		border-radius: 40px;
		position: relative;
		margin: 0 !important;
	}

	& .dm-rv-label:after {
		content: '';
		position: absolute;
		top: 5px;
		left: 5px;
		width: 20px;
		height: 20px;
		background: #fff;
		border-radius: 20px;
	}

	& .dm-rv-switch:checked + .dm-rv-label {
		background: ${COLORS.primary};
	}

	& .dm-rv-switch:checked + .dm-rv-label:after {
		left: calc(100% - 5px);
		transform: translateX(-100%);
	}

	& .rv-label span {
		color: #777;
		font-size: 14px;
		margin-right: 20px;
	}
`;

const ToggleButtonCmp = () => {
	const DEFAULT_MODE = true;
	const defaultMode = ls.get('rvMode') ?? DEFAULT_MODE;
	const [checked, setChecked] = useState(defaultMode);

	const message = checked === true ? STRINGS.improvedPerf : STRINGS.legacy;

  	return (
		<ToggleButton>
			<ReactTooltip />
			<div className='rv-label'>
				<span>{message}</span>
			</div>
			<div data-tip={STRINGS.toggleText}>
				<input type="checkbox" className="dm-rv-switch" id="switch" checked={checked} onChange={e => {
					setChecked(e.target.checked);
					ls.set('rvMode', e.target.checked);
					window.location.reload();
				}} />
				<label className="dm-rv-label" htmlFor="switch">{STRINGS.toggleText}</label>
			</div>
    </ToggleButton>
  );
};

export default ToggleButtonCmp;